module.exports = __webpack_public_path__ + "static/img/reward3.5cf83a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/reward3.png
// module id = kRKl
// module chunks = 1 3